import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 12a8 8 0 1 0 16 0a8 8 0 1 0 -16 0","key":"svg-0"}],["path",{"d":"M3 21l18 -18","key":"svg-1"}]]

/**
 * IconZeroConfig
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItemVyby1jb25maWciCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTQgMTJhOCA4IDAgMSAwIDE2IDBhOCA4IDAgMSAwIC0xNiAwIiAvPgogIDxwYXRoIGQ9Ik0zIDIxbDE4IC0xOCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/zero-config
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconZeroConfig = createReactComponent('outline', 'zero-config', 'ZeroConfig', __iconNode);

export default IconZeroConfig;